export { default as UpgradeSubscription } from './component';
